const NAVTABS_MY = Object.freeze({
  DATABSEHARDWARE: 'Database hardware',
  QUERYPERFORMANCE: 'Query performance',
  CONNECTIONS: 'Connections',
  METRICS: 'Metrics',
});

const NAVTABS_MS = Object.freeze({
  DATABASE: 'Database',
  NODE: 'Node',
});

const NAVTABS_ES = Object.freeze({
  ClUSTER: 'Cluster',
  NODE: 'Node',
});

const NAVTABS_CB = Object.freeze({
  CLUSTER_OVERVIEW: 'Cluster overview',
  NODE: 'Node',
  QUERIES: 'Queries',
  BUCKET: 'Bucket',
});

const NAVTABS = Object.freeze({
  HARDWARE: 'Hardware',
  QUERYPERFORMANCE: 'Query performance',
  CONNECTIONS: 'Connections',
  METRICS: 'Metrics',
  PERFORMANCE: 'Performance',
  RESOURCE: 'Resource',
});

const SUB_TYPES = Object.freeze({
  POS_INSTANCE: 'pos-instance',
  PS_QUERYPERFORMANCE: 'ps-queryperfomance',
  PS_CONNECTIONS: 'ps-connections',
  PS_METRICS: 'ps-metrics',
  ORA_INSTANCE: 'ora-instance',
  ORA_QUERYPERFORMANCE: 'ora-queryperfomance',
  ORA_CONNECTIONS: 'ora-connections',
  ORA_METRICS: 'ora-metrics',
  CAS_INSTANCE: 'cas-instance',
  CAS_QUERYPERFORMANCE: 'cas-queryperfomance',
  CAS_CONNECTIONS: 'cas-connections',
  CAS_METRICS: 'cas-metrics',
  CB_CLUSTER: 'cb-instance',
  CB_NODE: 'cb-node',
  CB_QUERIES: 'cb-queries',
  CB_BUCKET: 'cb-bucket',
  MY_INSTANCE: 'my-instance',
  MY_QUERYPERFORMANCE: 'my-queryperfomance',
  MY_CONNECTIONS: 'my-connections',
  MY_METRICS: 'my-metrics',
  MSSQL_PROCESSES: 'ms-processes',
  MSSQL_QUERY_PERFORMANCE: 'ms-query-performance',
  MSSQL_CONNECTIONS: 'ms-connections',
  MSSQL_HARDWARE: 'ms-hardware',
  MSSQL_METRICS: 'ms-metrics',
  MONGO_HARDWARE: 'mongo-hardware',
  MONGO_QUERYPERFORMANCE: 'mongo-queryperfomance',
  MONGO_PERFORMANCE: 'mongo-perfomance',
  MONGO_RESOURCE: 'mongo-resource',
  MONGO_CONNECTIONS: 'mongo-connections',
  MONGO_METRICS: 'mongo-metrics',
  MONGO_INSTANCE: 'mg-instance',
});

export const TABLE_KEYS = Object.freeze({
  LABEL: 'label',
  VALUE: 'value',
  TIMESTAMP: 'timeStamp',
  DEADLOCK: 'deadlock',
});

export const CLUSTER = 'cluster';
export const NODE = 'node';
export const BUCKET = 'bucket';

export const ASC = 'ASC';
export const DES = 'DES';

export const METAPROPERTY1 = 'metaProperty1';
export const METAPROPERTY3 = 'metaProperty3';

export const ONLINE = 'ONLINE';
export const OFFLINE = 'OFFLINE';

export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const MBConverter = 1048576;

export const BYTES_TO_MB_CONVERSION_VALUE = 1048576;
export const MS_TO_SECONODS_CONVERSION_VALUE = 1000;

export { NAVTABS_MY, NAVTABS_MS, NAVTABS_ES, NAVTABS_CB, NAVTABS, SUB_TYPES };
